let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("hUWfe"), load("ikSDi"), load("dJ5dO")]).then(() => parcelRequire('hvptt'));